<template>
  <div>
    <v-card class="mb-12" color="lighten-1">
      <v-data-table
        :headers="$t('app.products_headers')"
        :items="invoice.items"
        :items-per-page="20"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-dialog v-model="productDialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('app.new_product')}}</v-btn>
              </template>
              <v-card>
                    <ValidationObserver ref="obs">
                        <form @submit.prevent="submit()"  ref="form">
                <v-card-title>
                  <span class="headline">{{$t('app.new')}}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                
                    <v-row>
                      
                          <v-col cols="12" sm="6" md="2">
                            <v-text-field v-model="newProductsItem.fref" label="Ref"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <ValidationProvider name="description" rules="required">
                              <v-text-field
                                slot-scope="{errors,valid}"
                                :error-messages="errors"
                                :success="valid"
                                name="description"
                                v-model="newProductsItem.fname"
                                label="Description"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="2">
                            <ValidationProvider name="unit_price" rules="required">
                              <v-text-field
                                slot-scope="{errors,valid}"
                                :error-messages="errors"
                                :success="valid"
                                 name="unit_price"
                                v-model="newProductsItem.fprice"
                                type="number"
                                min="1"
                                :label="$t('app.unit_price')"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="2">
                            <ValidationProvider name="quantity" rules="required">
                              <v-text-field
                                slot-scope="{ errors,valid}"
                                :error-messages="errors"
                                :success="valid"
                                 name="quantity"
                                v-model="newProductsItem.fqty"
                                type="number"
                                min="1"
                                :label="$t('app.quantity')"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                   
                    </v-row>
                        
                    
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text type="submit">{{$t('app.save')}}</v-btn>
                </v-card-actions>
                 </form>
                   </ValidationObserver>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              <v-btn fab dark small color="red" @click="deleteProduct(index)">
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </td>
            <td>{{item.ref}}</td>
            <td>{{item.name}}</td>
            <td>{{item.price}}</td>
            <td>{{item.qty}}</td>
            <td>{{item.price * item.qty }}</td>
          </tr>
        </template>
        <template v-slot:item.name="props">
          <v-edit-dialog
            :return-value.sync="props.item.name"
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
          >
            {{ props.item.name }}
            <template v-slot:input>
              <v-text-field v-model="props.item.name" :label="$t('app.name')" single-line counter></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.price="props">
          <v-edit-dialog
            :return-value.sync="props.item.price"
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
          >
            {{ props.item.price }}
            <template v-slot:input>
              <v-text-field
                v-model="props.item.price"
                type="number"
                :label="$t('app.price')"
                single-line
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.qty="props">
          <v-edit-dialog
            :return-value.sync="props.item.qty"
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
          >
            {{ props.item.qty }}
            <template v-slot:input>
              <v-text-field
                type="number"
                v-model="props.item.qty"
                :label="$t('app.quantity')"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
      </v-data-table>
    </v-card>

    <v-btn
      :disabled="invoice.items.length < 1"
      color="primary"
      @click="nextStep"
    >{{$t('app.continue')}}</v-btn>

    <v-btn @click="prevStep" text>{{$t('app.back')}}</v-btn>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "StepThree",
  computed: {
    ...mapState(["invoice", "e1", "snack"])
  },
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      productDialog: false,
      newProductsItem: {
        fref: "",
        fname: "",
        fqty: 1,
        fprice: 1
      }
    };
  },
  methods: {
    ...mapActions([
      "nextStep",
      "addProduct",
      "deleteProduct",
      "prevStep",
      "updateSnack"
    ]),
    async submit() {
      const result = await this.$refs.obs.validate();
      if (result) {
        this.productDialog = false;
        this.addProduct(this.newProductsItem);
      }
    },
    save() {},
    cancel() {},
    open() {},
    close() {},
   
  }
};
</script>

<style scoped>
</style>